/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './job-e-doc-rest.service';
export * from './job-e-docs.dto';
